(function () {
  function updateStickyOffset() {
    const header = document.getElementById('shopify-section-header');
    const imageWrappers = document.querySelectorAll('.image-text-blocks__image-wrapper');

    if (header && imageWrappers.length > 0) {
      const headerHeight = header.offsetHeight;
      imageWrappers.forEach(function (wrapper) {
        wrapper.style.setProperty('--sticky-top-offset', headerHeight + 'px');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateStickyOffset);
  } else {
    updateStickyOffset();
  }

  window.addEventListener('resize', updateStickyOffset);
})();

